import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { useLocale } from '../contexts/LocaleContext';
import { flipIconName } from '../utils/rtl';

/** Drop-in Ionicons for directional glyphs (chevron/arrow back/forward):
 * swaps to the mirrored glyph in RTL. Icon fonts are never flipped by
 * dir="rtl" or rowDirection, so a hardcoded "chevron-forward" keeps
 * pointing right in Arabic unless it goes through flipIconName. */
export const DirectionalIcon: React.FC<React.ComponentProps<typeof Ionicons>> = ({ name, ...props }) => {
  const { isRTL } = useLocale();
  return <Ionicons {...props} name={flipIconName(isRTL, name as string) as any} />;
};
